export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8973.aee9ebc2.jpg";